import type { ShortVideo } from '~/composables/shorts/useFetchShorts';
import type { ShortsFilters } from '~/core/entities/property/filters';

interface ShortsEntryContext {
	items: ShortVideo[];
	filters: ShortsFilters;
	page: number;
	perPage?: number;
	hasMore: boolean;
}

/**
 * Estado transitório: itens do carrossel de origem ainda não exibidos no feed.
 * Preenchido antes de navegar para `/shorts/[commercialId]`; consumido no mount da página.
 * Permite que o feed continue a sequência do carrossel sem chamar a API para o primeiro "page".
 */
export function useShortsEntryContext() {
	return useState<ShortsEntryContext | null>(
		'shorts-entry-context',
		() => null
	);
}
